require('./RAAccordionBody.scss');
const PropTypes = require('prop-types');
const React = require('react');
const { OKLink } = require('commonsComponents/OKLink');
const {
    OKCollapsingToggler,
} = require('commonsComponents/OKCollapsingToggler');
class RAAccordionBody extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { disabled, rowId } = this.props;
        if (!disabled) {
            this.props.onAccordionClick(rowId);
        }
    }

    render() {
        const { information, togglerText } = this.props;
        return (
            <div className="ra-accrodion-body">
                <p className="ra-accrodion-body__text">{information}</p>
                <div
                    className={'ra-accrodion-header__columns__title--toggler'}
                    onClick={this.handleClick}
                >
                    <OKLink modifier="emphasize">{togglerText}</OKLink>
                    <OKCollapsingToggler
                        isIconSecondary={true}
                        isIconFixed={true}
                        isExpanded={true}
                    />
                </div>
            </div>
        );
    }
}

RAAccordionBody.propTypes = {
    information: PropTypes.string,
    disabled: PropTypes.bool,
    rowId: PropTypes.string.isRequired,
    togglerText: PropTypes.string.isRequired,
    onAccordionClick: PropTypes.func,
};

module.exports = RAAccordionBody;
